/**
 * @generated SignedSource<<38ac79bd1ceae98336c6c12cf485904b>>
 * @relayHash d40e79986defbb74ee71a42460f4e593
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fe516d70b362da33d2c9dc8e98f7d27b5868b10eb9ecfdd545bfad6f07fa6622

import type { ConcreteRequest } from 'relay-runtime';
export type useIsProductAdminUseIsProductAdminQuery$variables = Record<PropertyKey, never>;
export type useIsProductAdminUseIsProductAdminQuery$data = {
  readonly hasUserAccessAdminRole: boolean | null | undefined;
  readonly isSiteAdmin: boolean | null | undefined;
  readonly user: {
    readonly confluence: {
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined>;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type useIsProductAdminUseIsProductAdminQuery = {
  response: useIsProductAdminUseIsProductAdminQuery$data;
  variables: useIsProductAdminUseIsProductAdminQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  },
  {
    "kind": "ScalarField",
    "name": "isSiteAdmin"
  },
  {
    "kind": "ScalarField",
    "name": "hasUserAccessAdminRole"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useIsProductAdminUseIsProductAdminQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIsProductAdminUseIsProductAdminQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "d40e79986defbb74ee71a42460f4e593",
    "id": "fe516d70b362da33d2c9dc8e98f7d27b5868b10eb9ecfdd545bfad6f07fa6622",
    "metadata": {},
    "name": "useIsProductAdminUseIsProductAdminQuery",
    "operationKind": "query",
    "text": "query useIsProductAdminUseIsProductAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation,targetType}}},isSiteAdmin,hasUserAccessAdminRole}"
  }
};
})();

(node as any).hash = "179058bf05f0f539ac360b7a899d6923";

export default node;
